// extracted by mini-css-extract-plugin
module.exports = {"contents":"Ok","sectionHeading":"Pk"};